import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import { DATE_RANGES_FROM_SELECTOR, momentWeekType } from "@/utils/datepicker";
import DashboardV2Mixin from "@/mixins/DashboardV2Mixin.vue";
import { EVENTS, APP_PERIOD_DROPDOWN_ELEMENTS, FLOATING_COMPOUND_TABLE_STATES } from "@/utils/constants";
import CurrencyFilter from "@/components/new-filters/CurrencyFilter.vue";
import FlexColumn from "@/components/FlexColumn.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import ConversionPeriodTable from "@/components/dsp_report/ConversionPeriodTable.vue";
import ConsiderationPeriodTable from "@/components/dsp_report/ConsiderationPeriodTable.vue";
import LoyaltyPeriodTable from "@/components/dsp_report/LoyaltyPeriodTable.vue";
import ProductTable from "@/components/dsp_report/ProductTable.vue";
import OverviewTable from "@/components/dsp_report/OverviewTable.vue";
import DspFilters from "@/components/DspFilters.vue";
import PeriodControllers from "@/components/PeriodControllers.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import moment from "moment";
export default {
  name: "DSPReportingPage",
  components: {
    CurrencyFilter,
    FlexColumn,
    DspFilters,
    PeriodControllers,
    NavigationTabs,
    ConversionPeriodTable,
    ConsiderationPeriodTable,
    LoyaltyPeriodTable,
    ProductTable,
    OverviewTable
  },
  mixins: [LiteTableMixin, DashboardV2Mixin],
  beforeUnmount() {
    window.$bus.off(EVENTS.REFRESH_DSP, () => this.refreshAllKpis());
  },
  async mounted() {
    this.datePickerCommitterFunction = this.dspSetProductTablePeriod;
    this.$store.dispatch("dspSetDefaultCurrency");
    window.$bus.on(EVENTS.REFRESH_DSP, () => this.refreshAllKpis());
    await this.initializeSellersFilter(this.dspSellersFilterSet);
    await this.refreshDSPSellersSubFilters();
    window.$bus.trigger(EVENTS.FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE);
    this.$store.dispatch("dspSetProductTableGroupByElements");
    this.applyPeriodForDatePicker(this.periodGroupBy);
    this.refreshAllKpis();
    window.$bus.on(EVENTS.REFRESH_DSP_SELLERS_SUB_FILTERS, this.refreshDSPSellersSubFilters);
    window.$bus.on(EVENTS.REFRESH_DSP_MARKETPLACES_SUB_FILTERS, this.refreshDSPMarketPlacesSubFilters);
    window.$bus.on(EVENTS.REFRESH_DSP_CAMPAIGNS_SUB_FILTERS, this.refreshDSPCampaignsSubFilters);
    this.checkLocalStorageOnMarketplaceFilter = false;
  },
  data() {
    return {
      today: moment(),
      sellers: [],
      marketplaces: [],
      periodTableLoading: true,
      productTableLoading: true,
      overviewTableLoading: true,
      mediatorRefreshers: {
        PERIOD_TABLE: this.refreshPeriodTable,
        PRODUCT_TABLE: this.refreshProductTable,
        OVERVIEW_TABLE: this.refreshOverviewTable
      },
      DATE_RANGES_FROM_SELECTOR,
      checkLocalStorageOnMarketplaceFilter: true,
      FLOATING_COMPOUND_TABLE_STATES,
      releasedTabs: [{
        text: "Conversion",
        value: "conversion",
        activeBg: "#FFF6F0",
        activeColor: "#E05E0F",
        feature: 'dspConversion'
      }, {
        text: "Loyalty",
        value: "loyalty",
        activeBg: "#FFF6F0",
        activeColor: "#E05E0F",
        feature: 'dspLoyalty'
      }]
    };
  },
  computed: {
    ...mapState({
      currentPeriod: state => state.dsp_report.currentPeriod,
      periodSelectorOptions: state => state.dsp_report.periodSelectorOptions,
      overviewPeriodSelectorOptions: state => state.dsp_report.overviewPeriodSelectorOptions,
      tabs: state => state.dsp_report.tabs,
      currentTabValue: state => state.dsp_report.currentTabValue,
      currencies: state => state.dsp_report.currencies,
      sellers_filter: state => state.dsp_report.sellers_filter,
      marketplaces_filter: state => state.dsp_report.marketplaces_filter,
      campaigns: state => state.dsp_report.campaigns,
      line_items: state => state.dsp_report.line_items,
      productTable: state => state.dsp_report.product_table,
      productTableGroupBy: state => state.dsp_report.product_table.group_by_text,
      floatingTableState: state => state.dsp_report.product_table.state,
      isOmnyAdmin: state => state.auth.isOmnyAdmin,
      isOmnyUser: state => state.auth.isOmnyUser
    }),
    ...mapGetters(["dspGetPeriod", "dspGetOverviewPeriod", "dspGetPeriodCategory", "dspGetTab", "getSystemWeekType", "dspGetPeriodOptions", "currencyConfigQueryGet", "dateConfigQueryGet"]),
    computedTabs() {
      return this.tabs;
    },
    currentSellerIds() {
      return this.sellers_filter.filterValues;
    },
    currentMarketplaceIds() {
      return this.marketplaces_filter.selectedValues;
    },
    period: {
      set(value) {
        this.$store.dispatch("dspSetPeriod", value);
        this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
        this.refreshMediator(["PERIOD_TABLE", "PRODUCT_TABLE"]);
      },
      get() {
        return this.dspGetPeriod();
      }
    },
    overviewPeriod: {
      set(value) {
        this.$store.dispatch("dspSetOverviewPeriod", value);
        this.refreshOverviewTable();
      },
      get() {
        return this.dspGetOverviewPeriod();
      }
    },
    periodCategory: {
      set(value) {
        this.applyPeriodCategoryForDatePicker(this.datePickerDate, value);
        this.$store.dispatch("dspSetPeriodCategory", value);
      },
      get() {
        return this.dspGetPeriodCategory();
      }
    },
    tab: {
      async set(value) {
        this.$store.dispatch("dspSetTab", {
          tabIndex: value,
          tabValue: this.tabs[value].value
        });
      },
      get() {
        return this.dspGetTab();
      }
    },
    periodGroupBy() {
      return this.getPeriodGroupFromCurrentPeriod(this.currentPeriod, this.period);
    },
    getCurrentPeriodDate() {
      if (this.period === APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value) {
        return momentWeekType[this.getSystemWeekType]();
      }
      return this.currentPeriod[this.period].date;
    },
    periodOptions() {
      return this.dspGetPeriodOptions;
    },
    datePickerDate() {
      return this.productTable[this.currentTabValue].period;
    }
  },
  methods: {
    ...mapMutations(["dspSellersFilterSet", "dspMarketplacesFilterSet", "dspSetProductTablePeriod"]),
    ...mapActions(["getDspLineItems", "getDspOrders", "dspFetchOverviewTableData"]),
    handleErrorOccured() {
      this.announceNoAccounts();
      this.periodTableLoading = false;
    },
    async refreshPeriodTable() {
      this.periodTableLoading = true;
      await this.$store.dispatch("dspFetchPeriodTableData");
      this.periodTableLoading = false;
    },
    async refreshMediator(refresheeList) {
      refresheeList.forEach(refreshee => {
        this.mediatorRefreshers[refreshee]();
      });
    },
    async refreshProductTable() {
      this.productTableLoading = true;
      let previousPeriodCategory = this.periodCategory;
      this.periodCategory = "prev_period";
      const groupByFetch = this.productTable?.[this.currentTabValue]?.data?.[this.productTableGroupBy]?.fetch;
      if (groupByFetch) await this.$store.dispatch(groupByFetch);
      this.periodCategory = previousPeriodCategory;
      this.productTableLoading = false;
    },
    async handleDateChange(date) {
      if (!date) {
        date = this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
      }
      this.storeDatePickerDate(date);
      await this.refreshMediator(["PRODUCT_TABLE"]);
    },
    // Clear any evolution row selection without refetching.
    restoreEvolutionTable() {
      this.$store.commit("dspDeselectPeriodTable");
    },
    handleSetPeriodTable(date) {
      this.handleSetLiteTablePeriod(date, this.period, this.handleDateChange, this.datePickerCompareTitle(this.periodCategory));
    },
    refreshAllKpis() {
      this.refreshMediator(["OVERVIEW_TABLE", "PERIOD_TABLE", "PRODUCT_TABLE"]);
    },
    handleProductTableSort({
      sort,
      direction
    }) {
      this.$store.dispatch("dspSetProductTableSort", {
        sort,
        direction
      });
      this.refreshMediator(["PRODUCT_TABLE"]);
    },
    handleApplyForCurrencyChange() {
      if (this.currencies.isModified) {
        this.currencies.apply();
        this.$store.dispatch("currencyConfigSetCurrency", this.currencies.filterValues[0]);
        this.refreshAllKpis();
      }
    },
    async refreshDSPSellersSubFilters() {
      await this.initializeMarketplacesFilter(this.dspMarketplacesFilterSet, this.checkLocalStorageOnMarketplaceFilter);
      this.marketplaces_filter._key = "sales_channel";
      await this.refreshDSPMarketPlacesSubFilters();
    },
    async refreshDSPMarketPlacesSubFilters() {
      const campaigns_result = await this.getDspOrders({
        seller_id: this.currentSellerIds,
        marketplaces: this.currentMarketplaceIds
      });
      this.campaigns.initialize({
        list: campaigns_result,
        selected: [],
        key: "order_id",
        name: "campaigns"
      });
      await this.refreshDSPCampaignsSubFilters();
    },
    async refreshDSPCampaignsSubFilters() {
      const line_items_result = await this.getDspLineItems({
        seller_id: this.currentSellerIds,
        marketplaces: this.currentMarketplaceIds
      });
      this.line_items.initialize({
        list: line_items_result,
        selected: [],
        key: "line_item_id",
        name: "line_items"
      });
    },
    async refreshOverviewTable() {
      this.overviewTableLoading = true;
      await this.dspFetchOverviewTableData();
      this.overviewTableLoading = false;
    }
  }
};